// extracted by mini-css-extract-plugin
export var container = "style-module--container--rKXnm";
export var toggle = "style-module--toggle--zDwaj";
export var slider = "style-module--slider--30p6c";